import {TranslationObject} from '@colonist/i18n'
import {MapSettingEnum, ModeSettingEnum} from '../../../../../shared/GameEnums'
import {BaseMapData} from '../../../../../shared/map_data/BaseMapData'
import {MapDataController} from '../../../../../shared/map_data/MapDataController'
import {RoomState} from '../../../../../shared/RoomState'
import {LobbyImage} from '@colonist/types'
import {SocketLobbySend} from '../../../../shared/scripts/socket/SocketLobbySend'
import {createImgIn, setElementInnerHTML} from '../../../../shared/scripts/ui_utils/DomUtils'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {UIMRoomGamemodeMapCardView} from './UIMRoomCardView'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'

export class UIMRoomMapController {
    private readonly container: HTMLDivElement

    private lastGamemodeSelected: ModeSettingEnum
    private readonly cardList: {mapData: BaseMapData, element: UIMRoomGamemodeMapCardView, isMapAccessible: boolean}[] = []

    isSelectedMapAccessible: boolean = true

    constructor(container: HTMLDivElement, roomState: RoomState) {
        this.container = container
        this.lastGamemodeSelected = roomState.gameSetting.modeSetting
        this.build(roomState)
    }

    private build(roomState: RoomState) {
        const compatibleMaps = MapDataController.getMapDataCompatibleWithGameMode(roomState.gameSetting.modeSetting)
        for(const mapData of compatibleMaps) {
            if(!mapData.isActive) continue

            const mapTitle = UIMRoomMapController.getMapDisplayText(mapData)
            const imageBody = UIMRoomMapController.createImageCardBody(mapData.image)
            const updateMapSocketCallback = () => SocketLobbySend.clickedRoomSettingUpdateMapSetting(String(MapSettingEnum[mapData.mapEnum]))

            const canUserAccessMap = ClientUserState.userState?.items.hasAccessToPremiumMap(mapData)
            const isMapFree = UIMRoomMapController.addFreeAfterMapName(mapData)
            const isCardLocked = !canUserAccessMap && !isMapFree

            const card = new UIMRoomGamemodeMapCardView(this.container, mapTitle, mapData.image, imageBody, isCardLocked, updateMapSocketCallback)
            this.cardList.push({mapData: mapData, element: card, isMapAccessible: !isCardLocked})
        }

        this.update(roomState)
    }

    private static addFreeAfterMapName(mapData: BaseMapData): boolean {
        const isBaseMap = mapData.mapEnum == MapSettingEnum.Classic4P
        if(isBaseMap) return false

        const isWeeklyFreeMap = mapData.mapEnum == UIUtilsEjsVariables.freeMap
        if(isWeeklyFreeMap) return true

        if(!mapData.isMapPremium()) return true

        return false
    }

    private static createImageCardBody(image: LobbyImage): HTMLDivElement {
        const container = document.createElement('div')
        createImgIn(container, image, 'm-room-settings-card-map-image')
        return container
    }

    private static getMapDisplayText(mapData: BaseMapData): TranslationObject {
        const isOwned = false
        const isFree = UIMRoomMapController.addFreeAfterMapName(mapData)
        return BaseMapData.getMapDisplayText(mapData.name, isOwned, isFree)
    }

    update(roomState: RoomState) {
        this.refreshList(roomState)
        for(const card of this.cardList) {
            const isSelected = roomState.gameSetting.mapSetting == card.mapData.mapEnum
            card.element.setSelect(isSelected)
            if(isSelected) this.isSelectedMapAccessible = card.isMapAccessible
        }
    }

    private refreshList(roomState: RoomState) {
        if(this.lastGamemodeSelected == roomState.gameSetting.modeSetting) return
        this.lastGamemodeSelected = roomState.gameSetting.modeSetting
        setElementInnerHTML(this.container, {key: 'strings:colonistCommon.utils.emptyString'})
        this.cardList.length = 0
        this.build(roomState)
    }
}
